import { render } from "./ModalTopUp.vue?vue&type=template&id=5940a039&scoped=true&ts=true"
import script from "./ModalTopUp.vue?vue&type=script&lang=ts"
export * from "./ModalTopUp.vue?vue&type=script&lang=ts"

import "./ModalTopUp.vue?vue&type=style&index=0&id=5940a039&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5940a039"]])

export default __exports__